import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import swal from "sweetalert";
import "./login.css";
import Images from "../../ALL_Images/Images.js";
import loginjs from "./loginjs";
import Error500 from "./Error500";

import { GoogleLogin, googleLogout } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import axios from "../../axios.js";
import { useHCustomization } from "../../context";

global.peruserEmail = "";
global.loggedIn = true;
global.userfirstname = "";
global.usermobileno = "";
export var logged = null;
let apiKey = process.env.REACT_APP_URL;

export default function Login(props) {
  const { isAuth, setIsAuth } = useHCustomization();
  const history = useHistory();
  const [firstname, setFirstname] = useState("");
  const [email, setEmail] = useState("");
  const [lastname, setLastname] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [lemail, setLemail] = useState("");
  const [lpassword, setLpassword] = useState("");

  const [showError, setShowError] = useState(false);

  const [error, setError] = useState("");

  useEffect(() => {
    loginjs();

    const title = document.querySelector("title");
    title.innerText = `Login | Fodrix`;

    const desc = document.querySelector("meta[name='description']");
    desc.setAttribute("content", "Login into your Fodrix Account - Fodrix");

    const canonical = document.querySelector("link[rel='canonical']");
    canonical.setAttribute("href", "https://www.fodrix.com/login");
  }, []);

  const RegisterClick = async (e) => {
    e.preventDefault();
    const registerData = {
      email: email,
      password: password,
      firstname: firstname,
      lastname: lastname,
      mobile: mobile,
    };

    try {
      const res = await axios.post("/auth/register", registerData);
      const result = res.data;
      localStorage.setItem("auth", JSON.stringify({ ...result }));
      setIsAuth(localStorage.setItem("auth", JSON.stringify({ ...result })));
      history.push("/dashboard");
    } catch (error) {
      setError(error.response.data.messgage);
    }
  };

  const LoginClick = async (e) => {
    // e.preventDefault();
    const loginData = {
      email: lemail,
      password: lpassword,
    };

    try {
      const res = await axios.post("/auth/login", loginData);

      const result = res.data;

      localStorage.setItem("auth", JSON.stringify({ ...result }));
      setIsAuth(localStorage.setItem("auth", JSON.stringify({ ...result })));

      history.push("/dashboard");
    } catch (error) {
      setError(error.response.data.messgage);
    }
  };

  // const googleSuccess = async (res) => {
  //   const result = jwt_decode(res?.credential);
  //   localStorage.setItem(
  //     "auth",
  //     JSON.stringify({
  //       result,
  //     })
  //   );

  //   try {
  //     history.push("/dashboard");
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const googleError = () => {
  //   alert("Google Sign In was unsuccessful. Try again later");
  // };

  // useEffect(() => {
  // }, [error])

  // verify btn redirect to login
  return (
    <>
      {/* <Helmet>
        <title>Login | Fodrix</title>
        <meta
          name="description"
          content="Login into your Fodrix Account - Fodrix"
        />
      </Helmet> */}
      {/* {showError ? <Error500 setShowError={setShowError} /> : null} */}
      <div class="login-box">
        <img
          src={Images.fodrixiconnew}
          className="image_login"
          alt="Fodrix Logo"
          width="50px"
          height="137px"
          style={{ paddingBottom: "13px" }}
        />
        <div class="btn-group">
          <button
            type="button"
            className="btn btn--preferred signup-link"
            id="signup-box-link"
            onClick={loginjs}
            style={{ borderLeft: "1px solid #ddd" }}
          >
            Register
          </button>

          <button
            type="button"
            className="btn btn--preferred active login-link"
            id="login-box-link"
            style={{ backgroundColor: "#007bff", color: "white" }}
            onClick={loginjs}
          >
            Log in
          </button>
        </div>
        <div>{error}</div>
        <div class="email-login">
          <label for="u-form" className="label_login">
            Email
          </label>
          <div class="u-form-group">
            <input
              type="email"
              placeholder="Email"
              id="l_email"
              onChange={(val) => {
                setLemail(val.target.value);
              }}
              required
            />
          </div>
          <label for="u-form" className="label_login">
            Password
          </label>
          <div class="u-form-group">
            <input
              type="password"
              placeholder="Password"
              id="l_password"
              onChange={(val) => {
                setLpassword(val.target.value);
              }}
              required
            />
          </div>

          <div class="u-form-group">
            <button
              onClick={() => {
                if (lpassword !== "" || lemail !== "") {
                  LoginClick();
                } else {
                  swal("All fields are compulsory!");
                }
              }}
            >
              Log in
            </button>
          </div>

          <div class="foot-lnk">
            <a href="#forgot" style={{ color: "#007bff" }}>
              Forgot Password?
            </a>
          </div>

          {/* <div className="flex justify-center">
            <GoogleLogin
              onSuccess={googleSuccess}
              onFailure={googleError}
              cookiePolicy="single_host_origin"
            />
          </div> */}

          <div class="foot-lnk">
            <label for="pass">
              Don't Have an account?
              <a href="#" className="active signup-link" onClick={loginjs}>
                &nbsp;Register
              </a>
            </label>
          </div>
        </div>
        <form class="email-signup" onSubmit={RegisterClick}>
          <label for="u-form" className="label_login">
            First Name
          </label>
          <div class="u-form-group">
            <input
              type="text"
              placeholder="First Name"
              id="first_name"
              onChange={(val) => {
                setFirstname(val.target.value);
              }}
              required
            />
          </div>
          <label for="u-form" className="label_login">
            Last Name
          </label>
          <div class="u-form-group">
            <input
              type="text"
              placeholder="Last Name"
              id="last_name"
              onChange={(val) => {
                setLastname(val.target.value);
              }}
              required
            />
          </div>
          <label for="u-form" className="label_login">
            Email
          </label>
          <div class="u-form-group">
            <input
              type="email"
              placeholder="Email"
              id="email_register"
              onChange={(val) => {
                setEmail(val.target.value);
              }}
              required
            />
          </div>
          <label for="u-form" className="label_login">
            Mobile Number
          </label>
          <div class="u-form-group">
            <input
              type="number"
              placeholder="Mobile Number"
              id="mobile_register"
              onChange={(val) => {
                setMobile(val.target.value);
              }}
              required
            />
          </div>
          <label for="u-form" className="label_login">
            Password
          </label>
          <div class="u-form-group">
            <input
              type="password"
              placeholder="Password"
              id="password_register"
              onChange={(val) => {
                setPassword(val.target.value);
              }}
              required
            />
          </div>
          <div className="text-center privacy_text">
            By clicking on Create Account. I agree to Fodrix’s&nbsp;
            <a href="/privacyPolicy">Privacy Policy </a>and
            <a href="/tNc"> Terms and Conditions</a>.
          </div>
          <div class="u-form-group">
            <button type="submit">Register</button>
          </div>
          <div class="foot-lnk_r">
            <label for="pass">
              Already Have an account?
              <a href="#" className="login-link" onClick={loginjs}>
                &nbsp;Log in
              </a>
            </label>
          </div>
        </form>
      </div>
    </>
  );
}
